var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":"is-primary"},on:{"click":_vm.handleRestartTimer}},[_vm._v("プレイ再開 (ゲームマスター)")])}
var staticRenderFns = []

export { render, staticRenderFns }